<template>
  <div
    :class="{
      'f-input-wrapper': true,
      'is-with-dropdown': withDropdown,
      'is-multiple-fields': multipleFields,
      'is-append': append,
      'is-prepend-icon': prependIcon && prependIcon.length
      }">
      <template v-if="prependIcon && prependIcon.length">
        <f-icon :name="prependIcon" />
      </template>
      <slot/>
      <div
        v-if="append"
        class="f-input-wrapper-appendix">
        {{ append }}
      </div>
  </div>
</template>
<script>

export default {
  name: 'f-input-wrapper',
  props: {
    append: {
      type: String,
      default: null,
    },
    multipleFields: {
      type: Boolean,
      default: false
    },
    prependIcon: {
      type: String,
      default: null,
    },
    withDropdown: {
      type: Boolean,
      default: false
    }
  }
}
</script>
